export function setObjectValuesToNull(obj) {
    if (typeof obj === "object" && obj !== null) {
        for (let key in obj) {
            if (typeof obj[key] === "string" || typeof obj[key] === "number") {
                obj[key] = null
            } else {
                setObjectValuesToNull(obj[key])
            }
        }
    }
}

export function copyObject(obj: any) {
    if (typeof obj !== "object" || obj === null) {
        return obj
    }
    return JSON.parse(JSON.stringify(obj))
}
